import React, { Component } from 'react';
import api from '../api';
import { toast } from 'react-toastify';
import store from "../redux/store";
import Deceased from '../custom-components/eform/deceased';
import Executor from '../custom-components/eform/executor';
import Executor1 from '../custom-components/eform/executor1';
import Executor2 from '../custom-components/eform/executor2';
import NextOfKin from '../custom-components/eform/next-of-kin';
import EmploymentDetails from '../custom-components/eform/employment-details';
import InvestmentDetails from '../custom-components/eform/investment-details';
import IDMeans from '../custom-components/eform/id-means';
import BankDetails from '../custom-components/eform/bank-details';
import Confirmation from '../custom-components/eform/confirmation';
import { Header } from '../custom-components/header';
import loadScripts from '../../dassets/js/custom';



export default class CreateEForms extends Component {
  componentDidMount() {
    loadScripts();
  }
    constructor(props) {
        super(props);

        // this.onChangeFiles = this.onChangeFiles.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.sendEForm = this.sendEForm.bind(this);
        this.saveValues = this.saveValues.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);

        this.state = {
            step: 1
        }

        this.fieldValues = {
            type: "estate",
            deceased: {
                title: null,
                gender: null,
                surname: null,
                first_name: null,
                other_name: null,
            },
            executor: [
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    marital_status: null,
                    mother_maiden_name: null,
                    phone1: null,
                    phone2: null,
                    signature_path: null,
                    passport_path: null,
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    marital_status: null,
                    mother_maiden_name: null,
                    phone1: null,
                    phone2: null,
                    signature_path: null,
                    passport_path: null,
                },
                {
                    title: null,
                    gender: null,
                    surname: null,
                    first_name: null,
                    other_name: null,
                    email: null,
                    dob: null,
                    marital_status: null,
                    mother_maiden_name: null,
                    phone1: null,
                    phone2: null,
                    signature_path: null,
                    passport_path: null,
                }
            ],
            next_of_kin: {
                nok_surname: null,
                nok_first_name: null,
                nok_other_name: null,
                nok_relationship: null,
                nok_contact_add: null,
                nok_phone: null,
                nok_email: null,
            },
            employment_details: {
                emp_status: null,
                emp_date: null,
                emp_name: null,
                emp_add: null,
                occupation: null,
                source_of_income: null,
                source_of_investment: null,
                gross_yearly_income: null,
            },
            id_means: {
                id_type: null,
                number: null,
                issue_date: null,
                expiry_date: null,
                etcc: null,
            },
            bank_name: null,
            acct_name: null,
            acct_no: null,
            acct_type: null,
            opening_date: null,
            bvn: null,
            initial_investment: null,
            mode_of_payment: null,
            mode_of_communication: null,
            investment_objective: null,
            entity_name: null,
            full_name: null,
            identification: null,
            guarantor_dob: null,
            res_reg_add: null,
            prefered_account: null,
            heard_about_us: [],
            kyc_docs: [{ label: "Utility Bill", value: "Utility Bill"}],
            receive_reports: [],
        }
    }

    saveValues(fields, key = null, index = 0) {
        if (!key) {
            this.fieldValues = Object.assign({}, this.fieldValues, fields);
        } else if (index === "noindex") {
            this.fieldValues[key] = fields;
        } else {
            this.fieldValues[key][index] = fields;
        }
    }

    nextStep() {
        this.setState({
            step: this.state.step + 1
        })
    }

    // Same as nextStep, but decrementing
    previousStep() {
        this.setState({
            step: this.state.step - 1
        })
    }

    async onSubmit() {
        let i = 0;
        this.fieldValues.kyc_docs.find(o => {
            if (o.name === 'Utility Bill') {
                i++;
            }
        });

        if(this.fieldValues.kyc_docs.some(r=> ["Driver's Licence","International Passport","National ID Card","Permanent Voters Card"].includes(r.name))){
            i++;
        }

        if (i < 2) {
            toast.error("You need to upload an ID card and Utility Bill");
            return
        }
        
        this.fieldValues.kyc_docs = JSON.stringify(this.fieldValues.kyc_docs);
        this.fieldValues.heard_about_us = this.fieldValues.heard_about_us.toString();
        this.fieldValues.receive_reports = this.fieldValues.receive_reports.toString();
        const formData = new FormData();
        let fno = 0;
        if (this.fieldValues.executor[0].passport) {
            formData.append(`file${fno}`, this.fieldValues.executor[0].passport, this.fieldValues.executor[0].passport_path);
            fno++;
        }
        if (this.fieldValues.executor[0].signature) {
            formData.append(`file${fno}`, this.fieldValues.executor[0].signature, this.fieldValues.executor[0].signature_path);
            fno++;
        }
        if (this.fieldValues.executor[1].passport) {
            formData.append(`file${fno}`, this.fieldValues.executor[1].passport, this.fieldValues.executor[1].passport_path);
            fno++;
        }
        if (this.fieldValues.executor[1].signature) {
            formData.append(`file${fno}`, this.fieldValues.executor[1].signature, this.fieldValues.executor[1].signature_path);
            fno++;
        }
        if (this.fieldValues.executor[2].passport) {
            formData.append(`file${fno}`, this.fieldValues.executor[2].passport, this.fieldValues.executor[2].passport_path);
            fno++;
        }
        if (this.fieldValues.executor[2].signature) {
            formData.append(`file${fno}`, this.fieldValues.executor[2].signature, this.fieldValues.executor[2].signature_path);
            fno++;
        }
        formData.append('file_no', this.fieldValues.documents.length + fno);
        this.fieldValues.documents.forEach((doc, i) => {
            formData.append(`file${i + fno}`, doc.file, doc.path);
        });
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        };
        await api.post(`/forms/estate/upload`, formData, config,)
            .then(res => {
                console.log("Image uploaded successfully");
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });

        this.sendEForm();
    }

    sendEForm() {

        api.post(`/forms/estate`, this.fieldValues)
            .then(res => {
                toast.success("Thanks for taking time to submit your details, we will contact you via email.");
                this.props.history.push(`/`)
            }).catch(error => {
                let err = store.getState().error;
                if (err) {
                    toast.error(err.message);
                    this.props.history.push(err.redirectUrl)
                }
                console.log(error)
            });
    }

    render() {
        switch (this.state.step) {
            case 1:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><Deceased fieldValues={this.fieldValues.deceased}
                    nextStep={this.nextStep}
                    saveValues={this.saveValues} /></section>
            case 2:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><Executor fieldValues={this.fieldValues.executor[0]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 3:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><Executor1 fieldValues={this.fieldValues.executor[1]}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 4:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><Executor2 fieldValues={this.fieldValues.executor[2]}
                    previousStep={this.previousStep}
                    nextStep={this.nextStep}
                    saveValues={this.saveValues} /></section>
            case 5:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><NextOfKin fieldValues={this.fieldValues.next_of_kin}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 6:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><EmploymentDetails fieldValues={this.fieldValues.employment_details}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 7:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><IDMeans fieldValues={this.fieldValues.id_means}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 8:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><BankDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 9:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><InvestmentDetails fieldValues={this.fieldValues}
                    nextStep={this.nextStep}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            case 10:
                return <section><Header name="Estate Account Opening Form" step={this.state.step} max="10"/><Confirmation fieldValues={this.fieldValues}
                    submit={this.onSubmit}
                    previousStep={this.previousStep}
                    saveValues={this.saveValues} /></section>
            default:

        }
    }
}